import { getFilename } from "@openanalyst-ai/core/util/path"

function revealTrailingWhitespace(value: string) {
  const match = value.match(/[ \t]+$/)
  if (!match) return value
  const visible = match[0].replace(/ /g, "[space]").replace(/\t/g, "[tab]")
  return `${value.slice(0, -match[0].length)}${visible}`
}

export function displayPath(path: string, home?: string) {
  const value = home && path.startsWith(home) ? `~${path.slice(home.length)}` : path
  return revealTrailingWhitespace(value)
}

export function displayFilename(path: string) {
  return revealTrailingWhitespace(getFilename(path))
}
